import type { ReactNode } from "react";

import type { Devise, FormatClassement } from "./format";

/** Où l'argent d'une entrée arrive — les petites icônes sous le nom. */
export type Plateforme = "telegram" | "x" | "dropp";

/** Une ligne du classement : une créatrice, un chatteur, un affilié, un business… */
export interface EntreeClassement {
  /** Identité stable (défaut : rang + nom) — la clé quand le classement bouge
   *  en direct : une personne qui change de marche sort et entre en douceur. */
  id?: string;
  /** 1 = premier. Deux ex æquo portent le même rang. */
  rang: number;
  nom: string;
  /** Sous le nom, en gris : le vrai nom que l'admin voit derrière un pseudo… */
  sousNom?: ReactNode;
  /** Logo ou photo : une URL (rendue en tuile carrée arrondie) ou un nœud React
   *  (`<EyeOff />` pour qui se cache). Rien = l'initiale du nom. */
  icone?: ReactNode | string;
  /** `null` = chiffre caché (un collègue qui masque ses stats) → « — ». */
  montant: number | null;
  /** Cette entrée, c'est la personne qui regarde → badge « Toi ». */
  estMoi?: boolean;
  exAequo?: boolean;
  plateformes?: Plateforme[];
  /** Sous le montant, libre : la prime de la place, trois mini-chiffres… */
  detail?: ReactNode;
}

export interface OptionsFormat {
  /** `"montant"` (devise, défaut) ou `"nombre"` (compteur). */
  format?: FormatClassement;
  devise?: Devise;
  /** Suffixe gris après la valeur — « /mois ». */
  suffixe?: string;
  /** Un formateur à soi (prend la valeur en unités) — prime sur `format`/`devise`.
   *  Pour garder un format d'écran existant (« 248 $ » du classement des chatteurs). */
  formater?: (valeur: number) => string;
}

/** La clé React d'une entrée. */
export function cleDe(entree: EntreeClassement): string {
  return entree.id ?? `${entree.rang}-${entree.nom}`;
}
